import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { DisclosureBox, FormInput } from 'shared/components';
import { useEmailOptions } from 'shared/components/dashboard-mail-editor/hooks/use-email-options';
import SenderEmailSelect from 'shared/components/sender-email-select';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { isBlacklistEmailDomain } from 'shared/utils/is-blacklist-email-domain';
import { DashboardMailEditorCommonProps, ExtendedState } from '../types/common';
export interface EmailSettingsBlockProps<T extends ExtendedState> extends Pick<DashboardMailEditorCommonProps<T>, 'isPreFetching' | 'inModal' | 'errors' | 'tempState' | 'onChangeEmail' | 'disabled'> {}
const EmailSettingsBlock = t0 => {
  const $ = _c(44);
  const {
    disabled,
    errors,
    isPreFetching,
    onChangeEmail,
    tempState
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    data: options
  } = useEmailOptions();
  const isError = !!errors.fromName || !!errors.fromEmail;
  const t1 = tempState?.fromName;
  const t2 = tempState?.fromEmail;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = [t1, t2].filter(Boolean);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const description = t3.join(" \xB7 ");
  let t4;
  if ($[3] !== tempState?.fromEmail) {
    t4 = !!tempState?.fromEmail && isBlacklistEmailDomain(tempState?.fromEmail);
    $[3] = tempState?.fromEmail;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const isFromBlackList = t4;
  let t5;
  if ($[5] !== t) {
    t5 = t("dashboard.email.send_from");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== description) {
    t6 = description && <span className="text-text-secondary text-sm font-normal group-data-panel-open:hidden">{description}</span>;
    $[7] = description;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className="flex flex-col">{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = isPreFetching || !options;
  const t9 = tempState?.fromName || "";
  let t10;
  if ($[12] !== onChangeEmail || $[13] !== tempState) {
    t10 = e => tempState && onChangeEmail({
      ...tempState,
      fromName: e.target.value
    });
    $[12] = onChangeEmail;
    $[13] = tempState;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = errors.fromName;
  let t12;
  if ($[15] !== t) {
    t12 = t("dashboard.email.sender_name");
    $[15] = t;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== disabled || $[18] !== errors.fromName || $[19] !== t10 || $[20] !== t12 || $[21] !== t8 || $[22] !== t9) {
    t13 = <FormInput disabled={disabled} isPreFetching={t8} value={t9} onChange={t10} error={t11} required={true} label={t12} />;
    $[17] = disabled;
    $[18] = errors.fromName;
    $[19] = t10;
    $[20] = t12;
    $[21] = t8;
    $[22] = t9;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== isFromBlackList || $[25] !== t) {
    t14 = isFromBlackList && <span className="text-text-warning">{t("dashboard.email.free_emails-description")}</span>;
    $[24] = isFromBlackList;
    $[25] = t;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const t15 = tempState?.fromEmail || "";
  let t16;
  if ($[27] !== onChangeEmail || $[28] !== tempState) {
    t16 = value => tempState && onChangeEmail({
      ...tempState,
      fromEmail: value
    });
    $[27] = onChangeEmail;
    $[28] = tempState;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== disabled || $[31] !== errors.fromEmail || $[32] !== isPreFetching || $[33] !== t14 || $[34] !== t15 || $[35] !== t16) {
    t17 = <SenderEmailSelect description={t14} value={t15} onChange={t16} error={errors.fromEmail} required={true} disabled={disabled} isPreFetching={isPreFetching} />;
    $[30] = disabled;
    $[31] = errors.fromEmail;
    $[32] = isPreFetching;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t13 || $[38] !== t17) {
    t18 = <div className="tablet:flex-row flex flex-col items-baseline gap-2.5">{t13}{t17}</div>;
    $[37] = t13;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== isError || $[41] !== t18 || $[42] !== t7) {
    t19 = <DisclosureBox defaultOpen={true} invalid={isError} label={t7}>{t18}</DisclosureBox>;
    $[40] = isError;
    $[41] = t18;
    $[42] = t7;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  return t19;
};
export default EmailSettingsBlock;